export default {
    data() {
      return {
        props: {
          'width': '300px',
          'height': '300px',
          'zIndex': 'auto','maxWidth': '500px',
          'rotation': '0deg',
          'border': '0 none #000000',
          'boxShadow': '0 0 0 0 black initial',
          'borderRadius': '0 0 0 0',
          'paddingTop': '15px',
          'paddingLeft': '15px',
          'paddingRight': '15px',
          'paddingBottom': '15px',

          'src': 'https://webinar2.eb4us.com/',
          'webinarId':'',
          'webinarSecret':'',

          'animation': {
            'in': {
              'action': 'time',   //time/scroll/click/hover
              'time': 0,       // sec
              'scroll': 0,     // px
              'effect': 'none',
              'speed': 'slow',
              'infinite': false,
            },
            'out': {
              'action': 'time',   //time/scroll/click
              'time': 0,       // sec
              'scroll': 0,     // px
              'effect': 'none',
              'delay': '1',
              'speed': '1',
              'infinite': false,
            },
          },
        },
        elements: [],
        internal_config: {
          'width': '300px',
          'height': '300px',
          'zIndex': 'auto',
          'rotation': '0deg',
          'border': '0 none #000000',
          'boxShadow': '0 0 0 0 black initial',
          'borderRadius': '0 0 0 0',
          'paddingTop': '15px',
          'paddingLeft': '15px',
          'paddingRight': '15px',
          'paddingBottom': '15px',

          'src': 'https://webinar2.eb4us.com/',
           'webinarId':'',
           'webinarSecret':'',

          'animation': {
            'in': {
              'action': 'time',   //time/scroll/click/hover
              'time': 0,       // sec
              'scroll': 0,     // px
              'effect': 'none',
              'speed': 'slow',
              'infinite': false,
            },
            'out': {
              'action': 'time',   //time/scroll/click
              'time': 0,       // sec
              'scroll': 0,     // px
              'effect': 'none',
              'delay': '1',
              'speed': '1',
              'infinite': false,
            },
          },
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/editor/apps/Webinar/Model.js